import React from "react";
import { Typography, Container, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <Container sx={{ py: 4 }}>
      <Button variant="outlined" onClick={() => navigate('/')} sx={{ mb: 4 }}>
        ← Return to Search
      </Button>

      <Typography variant="h3" gutterBottom sx={{ color: "#8871ed", fontWeight: "bold" }}>
        About AetherSearch
      </Typography>
      
      <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
        Revolutionizing Card Discovery through Semantic Research
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom color="primary">
          The Genesis: From the Commander Table to Development
        </Typography>
        <Typography paragraph>
          I am an active <strong>Magic: The Gathering</strong> player. Every week, like many of you, I sit down with my playgroup for our <strong>Commander</strong> sessions. Anyone who builds decks knows the frustration of searching for that "perfect card" to replace an expensive staple or to enhance a specific synergy.
        </Typography>
        <Typography paragraph>
          Traditional search engines rely heavily on keyword matching. If you are looking for a specific effect but the wording varies slightly across Magic's 30-year history, standard tools often fail to find what you need. AetherSearch was born from this personal necessity: to create a support tool that is faster, more precise, and—above all—"intelligent."
        </Typography>

        <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4 }}>
          Beyond Keywords: Our Semantic Search Engine
        </Typography>
        <Typography paragraph>
          The core mission of AetherSearch is to provide a discovery experience that mimics how an experienced player thinks. Unlike common databases, our system doesn’t just scan for identical strings of text.
        </Typography>
        <Typography paragraph>
          The technological heart of AetherSearch is powered by an advanced <strong>Natural Language Processing (NLP)</strong> architecture:
        </Typography>
        
        <ul>
          <li>
            <Typography variant="body1">
              <strong>Semantic Vector Extraction:</strong> Every card is processed through a model that extracts a "semantic vector"—a mathematical representation of its meaning, mechanics, and functional role.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Functional Similarity Mapping:</strong> These vectors identify cards that perform the same tactical function, even with different terminology.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Vector Distance Calculation:</strong> Similarity is determined by calculating the <strong>mathematical distance (Cosine Similarity)</strong> between vectors. The closer two cards are in this multi-dimensional space, the more functionally similar they are.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4 }}>
          Our Mission
        </Typography>
        <Typography paragraph>
          At AetherSearch, we aim to provide players of all formats—from Commander to Modern—with a tool that is faster and more accurate than current industry standards. Whether you are hunting for a budget alternative or a niche card with a unique effect, our algorithm digs beneath the surface of the text to find the best possible match.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutUs;